import { Button, Col, Flex, Row } from 'antd';
import Text from 'antd/es/typography/Text';
import Title from 'antd/es/typography/Title';
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { ContentWrapp, FooterBlock, HeaderBlock, Logo } from '../../common';
import routesConfig from '../../../config/routes';

class NoMatch extends Component {
  render(): React.ReactNode {
    return (
      <ContentWrapp style={{ minHeight: '100vh' }}>
        <Row gutter={8} style={{ marginTop: 16, minHeight: 360 }}>
          <Col span={5}>
            <Logo />
          </Col>
          <Col span={19}>
            <HeaderBlock />
            <Flex justify="center" align="center" vertical style={{ height: 700 }}>
              <Title level={5}>404</Title>
              <Text>{'Такой страницы не существует'}</Text>
              <Link to={routesConfig.home}>
                <Button color="default" variant="outlined" style={{ marginTop: 30 }}>
                  На главную
                </Button>
              </Link>
            </Flex>
          </Col>
        </Row>
        <FooterBlock />
      </ContentWrapp>
    );
  }
}

export const NoMatchPage = NoMatch;
